module.exports = __webpack_public_path__ + "img/0xeeccd60ed722111f8400434dac3ba42c14d8beb1.75303c91.png";